import { useExposedProps } from "zudoku/hooks";
import { parseLocalizedDocsPath } from "../lib/docs-routes";
import { getDocsMessages } from "../lib/localization";

export function DocsNavigation({ mobile = false }: { mobile?: boolean }) {
  const { location } = useExposedProps();
  const { locale, suffix } = parseLocalizedDocsPath(location.pathname);
  const messages = getDocsMessages(locale);
  const api = suffix === "api" || suffix?.startsWith("api/");
  return (
    <nav
      className={`kaleo-docs-navigation${mobile ? " kaleo-docs-navigation-mobile" : ""}`}
      aria-label={messages.navigationDocumentation}
      data-pagefind-ignore="all"
    >
      <a href={`/${locale}/welcome`} aria-current={!api ? "page" : undefined}>
        {messages.navigationDocumentation}
      </a>
      <a href={`/${locale}/api`} aria-current={api ? "page" : undefined}>
        {messages.navigationApiReference}
      </a>
    </nav>
  );
}
